// Superadmin per-client switches.
//
// "Modules" holds exactly ONE switch per module page — the key is the
// CompanyModulePermission column behind CLIENT_MODULE_FLAGS in
// src/config/moduleKeys.js (mirrored on the backend). Turning a switch off
// hides that page and blocks its API for every role in the client (admin,
// manager, admin-level and plain user); only superadmin bypasses.
//
// "Platform Settings" are the remaining non-module behaviours that the app
// actually reads. Columns that nothing consumes (pttChannels, salarySlips,
// promotions, auditLogs, ...) are intentionally not listed any more.
export const moduleCategories = {
  "Modules": [
    { key: "employeeManagement", label: "Employees" },
    { key: "attendanceManagement", label: "Attendance" },
    { key: "leaveManagement", label: "Leave Management" },
    { key: "payrollManagement", label: "Payroll & Tax Calculator" },
    { key: "advancementRequests", label: "Advancements (Solfa)" },
    { key: "documentRequests", label: "Document Requests" },
    { key: "employeeActions", label: "Employee Changes" },
    { key: "reportsModule", label: "Reports" },
    { key: "calendarModule", label: "Calendar & To-dos" },
    { key: "privateMessaging", label: "Messages (Private & Group Chat)" },
    { key: "groupsModule", label: "Groups Management" },
    { key: "complaintsModule", label: "Complaints & Escalation Mapping" },
    { key: "departmentsModule", label: "Departments" },
    { key: "roleManagement", label: "Admin Levels" },
    { key: "systemSettings", label: "Company Configuration" },
    // Face check-in (CompanyModulePermission.biometricIntegration, overridable
    // per working company). Switching it off forces that company's
    // Company Configuration → Attendance → Face Check-in back to Off and hides
    // the selector; the admin picks Optional / Required while it is on.
    { key: "biometricIntegration", label: "Face Check-in (Biometric Integration)" },
  ],
  // Disabled for now: every employee is created with a login account, so the
  // with/without-accounts choice is hidden. Kept commented for future use —
  // re-enable together with the "Add As" block in AddEmployeeModal.jsx.
  // "Platform Settings": [
  //   {
  //     key: "allowImportModeChoice",
  //     label: "Choose Import Mode (with/without accounts)",
  //   },
  // ],
};
